import type {
  ChecklistCategory,
  ExpenseCategory,
  ItemKind,
  ItemStatus,
  MemberRole,
  PlaceCategory,
  PlaceStatus,
  TransportMode,
} from "@shared/types";

export const CATEGORY: Record<PlaceCategory, { label: string; emoji: string; color: string }> = {
  city: { label: "Город / база", emoji: "🏙️", color: "#0f766e" },
  sight: { label: "Достопримечательность", emoji: "🏛️", color: "#7c3aed" },
  nature: { label: "Природа", emoji: "⛰️", color: "#15803d" },
  beach: { label: "Пляж", emoji: "🏖️", color: "#0284c7" },
  food: { label: "Еда", emoji: "🍜", color: "#e2483d" },
  cafe: { label: "Кафе / кофе", emoji: "☕", color: "#a16207" },
  nightlife: { label: "Бары / ночь", emoji: "🍸", color: "#db2777" },
  hotel: { label: "Жильё", emoji: "🛏️", color: "#4f46e5" },
  activity: { label: "Активность", emoji: "🎯", color: "#ea580c" },
  shopping: { label: "Рынок / шопинг", emoji: "🛍️", color: "#c026d3" },
  transport: { label: "Транспорт", emoji: "✈️", color: "#475569" },
  other: { label: "Другое", emoji: "📍", color: "#64748b" },
};

export const PLACE_STATUS: Record<PlaceStatus, { label: string; short: string }> = {
  idea: { label: "Идея", short: "идея" },
  want: { label: "Хотим", short: "хотим" },
  visited: { label: "Были", short: "были" },
  skipped: { label: "Отказались", short: "нет" },
};

export const ITEM_KIND: Record<ItemKind, { label: string; emoji: string }> = {
  visit: { label: "Посещение", emoji: "📍" },
  activity: { label: "Активность", emoji: "🎯" },
  stay: { label: "Ночёвка", emoji: "🛏️" },
  transport: { label: "Переезд", emoji: "🚌" },
  note: { label: "Заметка", emoji: "📝" },
};

export const ITEM_STATUS: Record<ItemStatus, { label: string; tone: string }> = {
  idea: { label: "черновик", tone: "bg-amber-100 text-amber-800 dark:bg-amber-400/15 dark:text-amber-300" },
  planned: { label: "в плане", tone: "bg-jade-100 text-jade-800 dark:bg-jade-400/15 dark:text-jade-200" },
  booked: { label: "забронировано", tone: "bg-indigo-100 text-indigo-800 dark:bg-indigo-400/15 dark:text-indigo-200" },
  done: { label: "сделано", tone: "bg-slate-200 text-slate-700 dark:bg-white/10 dark:text-slate-300" },
  cancelled: { label: "отменено", tone: "bg-rose-100 text-rose-700 line-through dark:bg-rose-400/15 dark:text-rose-300" },
};

export const MODE: Record<TransportMode, { label: string; emoji: string; dash?: string }> = {
  flight: { label: "Самолёт", emoji: "✈️", dash: "2 8" },
  train: { label: "Поезд", emoji: "🚆" },
  sleeper_bus: { label: "Ночной автобус", emoji: "🌙", dash: "1 6" },
  bus: { label: "Автобус", emoji: "🚌" },
  car: { label: "Машина / трансфер", emoji: "🚗" },
  motorbike: { label: "Мотобайк", emoji: "🏍️" },
  boat: { label: "Лодка / паром", emoji: "⛴️", dash: "6 6" },
  taxi: { label: "Такси / Grab", emoji: "🚕" },
  walk: { label: "Пешком", emoji: "🚶", dash: "1 5" },
  other: { label: "Другое", emoji: "➡️" },
};

export const ROLE: Record<MemberRole, string> = { owner: "владелец", editor: "редактор", viewer: "только просмотр" };

export const CHECK_CAT: Record<ChecklistCategory, { label: string; emoji: string }> = {
  documents: { label: "Документы", emoji: "🛂" },
  booking: { label: "Брони", emoji: "🎫" },
  money: { label: "Деньги", emoji: "💳" },
  health: { label: "Здоровье и страховка", emoji: "🩺" },
  packing: { label: "Вещи", emoji: "🎒" },
  tech: { label: "Связь и приложения", emoji: "📱" },
  other: { label: "Другое", emoji: "📌" },
};

export const EXPENSE_CAT: Record<ExpenseCategory, { label: string; emoji: string; color: string }> = {
  transport: { label: "Транспорт", emoji: "✈️", color: "#0284c7" },
  stay: { label: "Жильё", emoji: "🛏️", color: "#4f46e5" },
  food: { label: "Еда", emoji: "🍜", color: "#e2483d" },
  activities: { label: "Активности", emoji: "🎯", color: "#ea580c" },
  shopping: { label: "Покупки", emoji: "🛍️", color: "#c026d3" },
  fees: { label: "Визы и сборы", emoji: "🧾", color: "#64748b" },
  other: { label: "Другое", emoji: "📌", color: "#94a3b8" },
};

/** Цвет дня: мягкая радуга вдоль маршрута */
export function dayColor(index: number, total: number) {
  const t = total <= 1 ? 0 : index / (total - 1);
  const hue = (168 + t * 250) % 360;
  return `hsl(${hue.toFixed(0)} 72% 42%)`;
}
